import React, { useState } from "react";
import { motion } from "framer-motion";
import Button from "../Buttons/Button";
import SmartTooltip from "../Info/SmartTooltip";

const CollapsibleWrapper = ({
  children,
  sidebar,
  source,
  sidebarTitle = "Filter",
  isSidebarOpenDefault = true,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(isSidebarOpenDefault);

  return (
    <div className="flex overflow-hidden gap-0">
      {source !== 1  && (
        <>
          <div className=" w-7 h-full mr-1">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className={`w-full h-full flex items-center justify-center text-xs shadow  ${isSidebarOpen ? "bg-gray-200 hover:bg-gray-100! text-black!" : "bg-gray-100 hover:bg-gray-200! text-black!"} duration-150`}
              style={{
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
              }}
            >
              <span className="material-symbols-outlined text-sm!">
                filter_alt
              </span>{" "}
              {isSidebarOpen ? "Hide" : "Show"} {sidebarTitle}
            </button>
          </div>
          <motion.div
            className="shrink-0 overflow-hidden flex flex-col"
            initial={false}
            animate={{ width: isSidebarOpen ? 384 : 0 }}
            transition={{ type: "spring", stiffness: 320, damping: 32 }}
          >
            {sidebar}
          </motion.div>
        </>
      )}
      <div className="flex-1 overflow-hidden flex">{children}</div>
    </div>
  );
};

export default CollapsibleWrapper;
